export enum AppScreen 
{
    MainMenu,
    IversBlitz,
    RA2YR,
    Streamers,
    More
}